module.exports = __webpack_public_path__ + "media/images/logotest-2d261852bebc3005de14c5ec94b3f41b.png";